import { render, staticRenderFns } from "./TwoStepValidation.vue?vue&type=template&id=75cf82bb&scoped=true&"
import script from "./TwoStepValidation.vue?vue&type=script&lang=js&"
export * from "./TwoStepValidation.vue?vue&type=script&lang=js&"
import style0 from "./TwoStepValidation.vue?vue&type=style&index=0&id=75cf82bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cf82bb",
  null
  
)

export default component.exports